// Состояние сессии для человека: цвет и короткая подпись.
//
// Раньше это было первое слово моноширинной строки внизу страницы, и
// «работает», «ошибка» и «переподключение» выглядели одинаково серыми. Цвет
// отвечает на вопрос «всё ли в порядке» без чтения, подпись — на вопрос «что
// именно».

import type { SessionState } from "../shared/messages.ts";

/**
 * `busy` — ждём, и это нормально (запуск, загрузка моделей); `warn` — связь
 * потеряна, но мы её восстанавливаем; `error` — сессия не состоится.
 */
export type Tone = "idle" | "busy" | "ok" | "warn" | "error";

export interface Status {
  tone: Tone;
  label: string;
}

/**
 * Состояние от воркера — в цвет и подпись.
 *
 * `waitedS` — сколько секунд идёт ожидание. Отсчёт не для красоты: без него
 * «грузит модели» и «повисло» выглядят одинаково, и непонятно, ждать дальше
 * или перезапускать.
 */
export function describeStatus(status: SessionState, waitedS: number): Status {
  switch (status.state) {
    case "idle":
      return { tone: "idle", label: "выключено" };
    case "connecting":
      return { tone: "busy", label: "подключение…" };
    case "loading":
      return { tone: "busy", label: `сервер грузит модели… ${waitedS} с` };
    case "running":
      return { tone: "ok", label: "работает" };
    case "retrying":
      return { tone: "warn", label: `переподключение через ${Math.round(status.inMs / 1000)} с` };
    case "failed":
      return { tone: "error", label: "ошибка" };
  }
}

/** Шаг запуска на нашей стороне: микрофон, вывод, сокет. */
export function startingStep(what: string): Status {
  return { tone: "busy", label: what };
}
